import clientLoginLogo from "../../assets/ClientAsserts/Logo/clientLoginLogo.svg";
import clientLogo from "../../assets/ClientAsserts/Logo/clientLogo.svg";
import glFunnelImage from "../../assets/ClientAsserts/Logo/gl-funnel-login-logo.svg";
import glFunnelLogo from "../../assets/ClientAsserts/Logo/GL Funnel Logo.svg";
import dashboardIcon from "../../assets/Icons/DashboardIcon.svg";
import dashboardIconActive from "../../assets/Icons/dashboardIconActive.svg";
import analyticsIcon from "../../assets/Icons/AnalyticsIcon.svg";
import analyticsIconActive from "../../assets/Icons/AnalyticsIconActive.svg";
import pipelineIcon from "../../assets/Icons/PipelineIcon.svg";
import pipelineIconActive from "../../assets/Icons/PipeLineIconActive.svg";
import leadDbIcon from "../../assets/Icons/LeadGroupIcon.svg";
import leadDbIconActive from "../../assets/Icons/LeadGroupIconActive.svg";
import setupIcon from "../../assets/Icons/Setting Icon.svg";
import setupIconActive from "../../assets/Icons/SettingIconActive.svg";
import totalCallAnalytics from "../../assets/Icons/Phone-icon.svg";
import totalSiteVisitAnalytics from "../../assets/Icons/TotalSiteVisitAnalytics-Icon.svg";
import totalBookingsAnalytics from "../../assets/Icons/TotalBookingAnalytic-Icon.svg";
import totalFullyRegisteredAnalytics from "../../assets/Icons/FullyRegisteredAnalytic-Icon.svg";
import totalDealLostAnalytics from "../../assets/Icons/TotalDealLostAnalytic-Icon.svg";
import pipelineUserIcon from "../../assets/Icons/PipelineCardUser-Icon.svg";
import freshIcon from "../../assets/Icons/plant 2.svg";
import customerIcon from "../../assets/Icons/Customer-Icon.svg";
import registeredClient from "../../assets/Icons/Customer-Icon.svg";
import notInterestedIcon from "../../assets/Icons/Not-Interested-Icon.svg";
import dealingIcon from "../../assets/Icons/Dealing-icon.svg";
import dealLostIcon from "../../assets/Icons/Deal-Lost-Icon.svg";
import unansweredIcon from "../../assets/Icons/Unanswered-Icon.svg";
import interestedIcon from "../../assets/Icons/Interested-Icon.svg";
import confusedEmoji from "../../assets/Icons/confusedEmoji.svg";
import neutralEmoji from "../../assets/Icons/NeutralEmoji.svg";
import NAEmoji from "../../assets/Icons/NA-Emoji.svg";
import excitedEmoji from "../../assets/Icons/ExcitedEmoji.svg";
import ThinkingEmoji from "../../assets/Icons/ThinkingEmoji.svg";
import previousPagination from "../../assets/Icons/paginationLeft.svg";
import nextPagination from "../../assets/Icons/paginationRight.svg";
import searchIcon from "../../assets/Icons/search.svg";
import loginImage from "../../assets/ClientAsserts/Logo/glfunnel-Login-Image.svg";
import ReportIconActive from "../../assets/Icons/ReportIconActive.svg";
import ReportIcon from "../../assets/Icons/ReportIcon.svg";
import registrationReportHeader from "../../assets/ClientAsserts/DealCostSheetImages/header.svg";
import registrationReportFooter from "../../assets/ClientAsserts/DealCostSheetImages/footer.svg";
import downloadIcon from "../../assets/Icons/download_icon.svg";
import infoIcon from "../../assets/Icons/info.svg";
import excelImage from "../../assets/Icons/leadBulkImage.png";
import pencilIcon from "../../assets/Icons/pencil.svg";
import checkIcon from "../../assets/Icons/tick.svg";
import cancelIcon from "../../assets/Icons/wrong tick.svg";
import RetrySuitable from "../../assets/Icons/Retry-Suitable-Icon.svg";
import addUploadIcon from "../../assets/Icons/addUploadIcon.svg";
import mailIcon from "../../assets/Icons/Letter-cover-icon.svg";
import whatsAppIcon from "../../assets/Icons/Whatsapp-Icons.svg";
import smsIcon from "../../assets/Icons/sms-logo.svg";
import spinwheelcreateIcon from "../../assets/Icons/spinwheel create.svg";
import clipboardCopyIcon from "../../assets/Icons/copy_Icon.svg";
import tickIcon from "../../assets/Icons/tick-black.svg";
import checkIn from "../../assets/Icons/checkIn.svg";
import checkOut from "../../assets/Icons/checkOut.svg";
import breakTime from "../../assets/Icons/breakTime.svg";
import activityProgress from "../../assets/Icons/activity-summary.svg";
import missedCall from "../../assets/Icons/missedCall.svg";
import incomingCall from "../../assets/Icons/incomingCall.svg";
import outGoingCall from "../../assets/Icons/outGoingCall 33.svg";
import timerIcon from "../../assets/Icons/timer.svg";
import noCallLog from "../../assets/Icons/noCallLog.svg";
import confirmationWarning from "../../assets/Icons/confirmatio-warning-icon.svg";
import recycleIcon from "../../assets/Icons/refresh-icon.svg";
import filterIcon from "../../assets/Icons/filter_alt.svg";
import uploadIcon from "../../assets/Icons/upload.svg";
import leftArrow from "../../assets/Icons/leftArrow.svg";
import rightArrow from "../../assets/Icons/rightArrow-icon.svg";

import diamond from "../../assets/Icons/Diamond.svg";
import silver from "../../assets/Icons/Silver.svg";
import gold from "../../assets/Icons/Gold.svg";
import bronze from "../../assets/Icons/Bronze.svg";

import reportBanner from "../../assets/Icons/reportBanner.svg";
import notFound from "../../assets/Icons/notFound.svg";
import notFoundImage from "../../assets/Icons/noMemberImage.svg";

import glfunnalTitle from "../../assets/Icons/gl-funnal.svg";

import downloadIcon2 from "../../assets/Icons/downloadIcon.svg";



import approveImage from "../../assets/Icons/approve.svg";

import aadhaImage from "../../assets/Icons/aadhar.svg";

import assignImage from "../../assets/Icons/assignImage.svg";

import leadEmpty from "../../assets/LeadImages/LeadEmpty.png";

import AllLeadIcon from "../../assets/leads_Icon/AllLeads.svg";
import DealLost from "../../assets/leads_Icon/DealLost.svg";
import Dealing from "../../assets/leads_Icon/Dealing.svg";
import FollowUp from "../../assets/leads_Icon/Follow-Up.svg";
import Fresh from "../../assets/leads_Icon/Fresh.svg";
import NotInterested from "../../assets/leads_Icon/NotInterested.svg";
import RegisteredClient from "../../assets/leads_Icon/Registered Client.svg";
import RetrySuitableIcons from "../../assets/leads_Icon/RetrySuitable.svg";
import Unanswered from "../../assets/leads_Icon/Unanswered.svg";
import Unassigned from "../../assets/leads_Icon/Unassigned.svg";
import Junk from "../../assets/leads_Icon/Junk.svg";
import Response from "../../assets/leads_Icon/Response.svg";
import CallBack from "../../assets/leads_Icon/CallBack.svg";

import autoEmpty from "../../assets/AutoMessage/emptyList.png";

import assignSummaryIcon from "../../assets/Lead DB Menu Icons/AssignedSummaryIcon.svg";
import newLeadIcon from "../../assets/Lead DB Menu Icons/NewLeadIcon.svg";
import reassignIcon from "../../assets/Lead DB Menu Icons/ReassignIcon.svg";

import faceBookIcon from "../../assets/Webhooks Icon/facebookIcon.png";
import googleIcon from "../../assets/Webhooks Icon/googleIcon.png";
import ZapierIcon from "../../assets/Webhooks Icon/ZapierIcon.png";
import IntegrationIcon from "../../assets/Webhooks Icon/IntegrationIcon.png";
import SettingFaceBookImage from "../../assets/Webhooks Icon/SettingImage.png";

import villaIcon from "../../assets/PropertyIcons/VillaIcon.svg";
import AcresCentsIcon from "../../assets/PropertyIcons/Acres&CentsIcon.svg";
import ApartmentIcon from "../../assets/PropertyIcons/ApartmentIcon.svg";
import LayoutIcon from "../../assets/PropertyIcons/LayoutIcon.svg";
import glPageEmpty from "../../assets/GLpageSmapleImages/GLPageEmpty.png";

import directionIcon from "../../assets/PropertyIcons/diraction.png";

import villaFurnished from "../../assets/PropertyIcons/VillaSectionIcon/FurnishedIcon.svg";
import villaNonFurnished from "../../assets/PropertyIcons/VillaSectionIcon/UnfurnishedIcon.svg";
import villaSemiFurnished from "../../assets/PropertyIcons/VillaSectionIcon/SemiFurnishedIcon.svg";

import teamsIcon from "../../assets/SetupmenuIcons/teamsIcons.png";
import usersIcon from "../../assets/SetupmenuIcons/usersIcons.png";
import AutoMsgIcon from "../../assets/SetupmenuIcons/Automated MessageIcons.png";
import CpManageIcon from "../../assets/SetupmenuIcons/CP ManagementIcons.png";
import ContentHubIcon from "../../assets/SetupmenuIcons/Content HubIcons.png";
import glPageIcon from "../../assets/SetupmenuIcons/GL PagesIcons.png";
import IncentivesIcons from "../../assets/SetupmenuIcons/IncentivesIcons.png";
import IntegrationIcons from "../../assets/SetupmenuIcons/IntegrationIcons.png";
import MarketingHubIcon from "../../assets/SetupmenuIcons/Marketing HubIcons.png";
import PropertiesIcons from "../../assets/SetupmenuIcons/PropertiesIcons.png";
import PropertyInventoryIcon from "../../assets/SetupmenuIcons/Property InventoryIcons.png";
import SpinWeelIcon from "../../assets/SetupmenuIcons/Spin WheelIcons.png";
import APIIcons from "../../assets/SetupmenuIcons/API Image.png";
import ImterestSourceIcon from "../../assets/SetupmenuIcons/Interest SourceIcons.png";

import LeadHistotyIcon from "../../assets/HotLeadIcon/LeadHistory.svg";
import LeadCancelIcon from "../../assets/HotLeadIcon/Leadcancel.svg";
import LeadSendIcon from "../../assets/HotLeadIcon/Leadsend.svg";

import teamIcon  from "../../assets/teamIcon.jpg"

import interestLocationIcon  from "../../assets/InterestAndSourceIcons/LocationtagsIcon.png";
import interestSourceIcon  from "../../assets/InterestAndSourceIcons/LeadsourceIcon.png";
import interstTagIcon from "../../assets/InterestAndSourceIcons/InterestIcon.png";

import teamEmpty from "../../assets/TeamAnduserEmptyImage/teamEmpty.png";


import UploadedHistoryIcon from "../../assets/Lead DB Menu Icons/uploadHistoryIcon.svg";
import followUpActive from "../../assets/Icons/followUpActive.svg";
import followUpInactive from "../../assets/Icons/folowUpInactive.svg";

import emptyFollowUp from "../../assets/followups Images/empty_Kanban.png";


import leadSourceArrow from "../../assets/LeadSourceIcons/rightIcon.png"
import leadSourceManualIcon  from "../../assets/LeadSourceIcons/manualIcon.png"
import leadSourceBulkIcon from "../../assets/LeadSourceIcons/bulkIcon.png"
import emptyLeadSourceIcon from "../../assets/LeadSourceIcons/emptyLeadSourceIcon.png"

import tOneImage1 from "../../assets/GLPagesTemplateImages/Template1/Image1.png"
import tOneImage2 from "../../assets/GLPagesTemplateImages/Template1/Image2.png"
import tOneImage3 from "../../assets/GLPagesTemplateImages/Template1/Image3.png"
import tOneImage4 from "../../assets/GLPagesTemplateImages/Template1/Image4.png"
import tOneImage5 from "../../assets/GLPagesTemplateImages/Template1/Image5.png"
import tOneImage6 from "../../assets/GLPagesTemplateImages/Template1/Image6.png"
import tOneImage7 from "../../assets/GLPagesTemplateImages/Template1/Image7.png"
import tOneImage8 from "../../assets/GLPagesTemplateImages/Template1/Image8.png"
import tOneImage9 from "../../assets/GLPagesTemplateImages/Template1/Image9.png"


import tTowImage1 from "../../assets/GLPagesTemplateImages/Template 2/Image1.png"
import tTowImage2 from "../../assets/GLPagesTemplateImages/Template 2/Image2.png"
import tTowImage3 from "../../assets/GLPagesTemplateImages/Template 2/Image3.png"
import tTowImage4 from "../../assets/GLPagesTemplateImages/Template 2/Image4.png"
import tTowImage5 from "../../assets/GLPagesTemplateImages/Template 2/Image5.png"
import tTowImage6 from "../../assets/GLPagesTemplateImages/Template 2/Image6.png"
import tTowImage7 from "../../assets/GLPagesTemplateImages/Template 2/Image7.png"
import tTowImage8 from "../../assets/GLPagesTemplateImages/Template 2/Image8.png"
import tTowImage9 from "../../assets/GLPagesTemplateImages/Template 2/Image9.png"

import GLListICon from "../../assets/GLpageSmapleImages/GLListIcon.svg";
import GLPropertyIcon from "../../assets/GLpageSmapleImages/GLPropertyIcon.svg"

import GLImage1 from "../../assets/GLPagesTemplateImages/GlListTemplate/Image1.png";
import GLImage2 from "../../assets/GLPagesTemplateImages/GlListTemplate/Image2.png";
import GLImage3 from "../../assets/GLPagesTemplateImages/GlListTemplate/Image3.png";
import GLImage4 from "../../assets/GLPagesTemplateImages/GlListTemplate/Image4.png";
import GLImage5 from "../../assets/GLPagesTemplateImages/GlListTemplate/Image5.png";
import GLImage6 from "../../assets/GLPagesTemplateImages/GlListTemplate/Image6.png";

import ResalePlotIcon from "../../assets/PropertyIcons/realPlotIcon.svg";

// Function to get Logos
export const getLogos = () => {
  return {
    clientLoginLogo,
    clientLogo,
    glFunnelImage,
    glFunnelLogo,
    glfunnalTitle,
  };
};

// Function to get Logos
export const getIcons = () => {
  return {
    dashboardIcon,
    dashboardIconActive,
    analyticsIcon,
    analyticsIconActive,
    pipelineIcon,
    pipelineIconActive,
    leadDbIcon,
    leadDbIconActive,
    followUpInactive,
    followUpActive,
    ResalePlotIcon,
    setupIcon,
    setupIconActive,
    totalCallAnalytics,
    totalBookingsAnalytics,
    totalDealLostAnalytics,
    totalFullyRegisteredAnalytics,
    totalSiteVisitAnalytics,
    pipelineUserIcon,
    freshIcon,
    interestedIcon,
    notInterestedIcon,
    dealLostIcon,
    dealingIcon,
    uploadIcon,
    customerIcon,
    unansweredIcon,
    previousPagination,
    nextPagination,
    confusedEmoji,
    NAEmoji,
    neutralEmoji,
    ThinkingEmoji,
    excitedEmoji,
    searchIcon,
    loginImage,
    ReportIconActive,
    ReportIcon,
    registrationReportHeader,
    registrationReportFooter,
    downloadIcon,
    infoIcon,
    excelImage,
    pencilIcon,
    checkIcon,
    cancelIcon,
    registeredClient,
    RetrySuitable,
    addUploadIcon,
    mailIcon,
    filterIcon,
    smsIcon,
    whatsAppIcon,
    spinwheelcreateIcon,
    clipboardCopyIcon,
    tickIcon,
    checkIn,
    checkOut,
    breakTime,
    activityProgress,
    missedCall,
    incomingCall,
    timerIcon,
    noCallLog,
    outGoingCall,
    confirmationWarning,
    recycleIcon,
    leftArrow,
    rightArrow,
    diamond,
    silver,
    gold,
    bronze,
    reportBanner,
    notFound,
    downloadIcon2,
    approveImage,
    aadhaImage,
    notFoundImage,
    assignImage,
    leadEmpty,
    AllLeadIcon,
    DealLost,
    Dealing,
    FollowUp,
    Fresh,
    NotInterested,
    RegisteredClient,
    RetrySuitableIcons,
    Unanswered,
    Unassigned,
    Response,
    CallBack,
    autoEmpty,
    assignSummaryIcon,
    newLeadIcon,
    reassignIcon,
    faceBookIcon,
    googleIcon,
    ZapierIcon,
    IntegrationIcon,
    SettingFaceBookImage,
    villaIcon,
    ApartmentIcon,
    AcresCentsIcon,
    LayoutIcon,
    glPageEmpty,
    directionIcon,
    villaFurnished,
    villaNonFurnished,
    villaSemiFurnished,
    Junk,
    teamsIcon,
    usersIcon,
    AutoMsgIcon,
    CpManageIcon,
    ContentHubIcon,
    glPageIcon,
    IncentivesIcons,
    IntegrationIcons,
    MarketingHubIcon,
    PropertiesIcons,
    PropertyInventoryIcon,
    SpinWeelIcon,
    APIIcons,
    ImterestSourceIcon,
    LeadHistotyIcon,
    LeadCancelIcon,
    LeadSendIcon,
    teamIcon,
    interestLocationIcon,
    interestSourceIcon,
    interstTagIcon,
    teamEmpty,
    UploadedHistoryIcon,
    emptyFollowUp,

    leadSourceArrow,
    leadSourceManualIcon,
    leadSourceBulkIcon,
    emptyLeadSourceIcon,



    tOneImage1,
    tOneImage2,
    tOneImage3,
    tOneImage4,
    tOneImage5,
    tOneImage6,
    tOneImage7,
    tOneImage8,
    tOneImage9,
    

    tTowImage1,
    tTowImage2,
    tTowImage3,
    tTowImage4,
    tTowImage5,
    tTowImage6,
    tTowImage7,
    tTowImage8,
    tTowImage9,

    GLListICon,
    GLPropertyIcon,

    GLImage1,
    GLImage2,
    GLImage3,
    GLImage4,
    GLImage5,
    GLImage6,
    

  };

};

export const leadStatusMap = {
  unAssigned: { label: "Unassigned Fresh", color: "#EBEBFF" },
  L0CTrn0qwWlHWvq2gXDm: { label: "Assigned Fresh", color: "#EBEBFF" },
  Auf9SQFhiKF7WRM9ZiTA: { label: "Follow-up", color: "#E3F3FC" },
  gJxbL16EjFbzDFCoQU5G: { label: "Dealing", color: "#D6F3EA" },
  znvixWClH1PDoCXO4Aat: { label: "Registered Client", color: "#8BDBBE" },
  "8337Bve50LqwfrkveUrY": { label: "Deal Lost", color: "#D8FFE0" },
  yUuWlPRZEosdOeLzyL0f: { label: "Unanswered", color: "#FBE7E5" },
  VH26wB3VgVXBzoBJiqml: { label: "Not Interested", color: "#FBE7E5" },
  PdCEXW0VIoVviuqvjdWc: { label: "Retry Suitable", color: "#B1C8F5" },
  "9XSuBds8XzEmvVNDr3yr": { label: "Junk", color: "#8BDBBE" },
  Wx3ErE2NkJPooQT06Sm9: { label: "Response", color: "#C7EBFF" },
  ZCjUyJXo9KDBmdnlmWVq: { label: "Call Back", color: "#FFF4B5" },
};

export const leadCharacterEmoji = {
  "Not Applicable": NAEmoji,
  None: NAEmoji,
  Excited: excitedEmoji,
  Neutral: neutralEmoji,
  Thinking: ThinkingEmoji,
  Confused: confusedEmoji,
};

export function getNumericValue(num) {
  if (typeof num === "number") return num;
  if (typeof num === "string") {
    return parseFloat(num.replace(/[^0-9.]/g, "")) || 0;
  }
  return 0;
}

export function formatNumber(num) {
  if (num >= 1e7) {
    return (
      (Math.round((num / 1e7) * 100) / 100).toFixed(2).replace(/\.00$/, "") +
      "C"
    );
  }
  if (num >= 1e5) {
    return (
      (Math.round((num / 1e5) * 100) / 100).toFixed(2).replace(/\.00$/, "") +
      "L"
    );
  }
  if (num >= 1e3) {
    return (
      (Math.round((num / 1e3) * 100) / 100).toFixed(2).replace(/\.00$/, "") +
      "K"
    );
  }
  return num.toLocaleString("en-IN");
}

export const bulkFolderPath = "bulkUpload";

export const MenuItem = ({
  icon,
  iconAlt,
  label,
  count,
  onClick,
  textColor = "text-gray-800",
}) => (
  <div
    onClick={onClick}
    className="flex items-center gap-3 px-4 py-2 hover:bg-gray-100 cursor-pointer"
  >
    {icon && <img src={icon} className="h-5 w-5" />}
    {iconAlt && <>
    {iconAlt}
    </>}

    <div className={`${textColor} hover:text-customGreen font-medium`}>
      {label}{" "}
      {count && <span className="text-sm text-gray-500">({count})</span>}
    </div>
  </div>
);

export const Divider = () => <div className="border-t border-gray-200 mx-4" />;

export const downloadFile = (url, filename) => {
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const formatDate = (date) => {
  const d = new Date(date);
  const month = String(d.getMonth() + 1).padStart(2, '0'); 
  const day = String(d.getDate()).padStart(2, '0');
  const year = d.getFullYear();
  return `${month}-${day}-${year}`;
};

const userData = JSON.parse(localStorage.getItem("userData"));
export const userRole = userData?.user?.role;
export const userId = userData?.user?.id;
export const userUid = userData?.user?.uid;
export const teamIds = userData?.teamId?.map((t) => t.id);
export const teamList = userData?.teamId;
